import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Shared "nothing to show yet" block for analytics surfaces.
 *
 * Analytics panels are prone to a specific misreading: an empty result rendered
 * through the normal chart path looks like a real measurement of zero. This
 * makes the difference explicit — "nobody has attempted" is not "everybody
 * scored nothing". Uses the same illustration the batch highlights table
 * already uses, so it reads as part of the existing product.
 */
const NoDataPanel = ({
  message = 'No data available',
  hint = null,
  height = 240,
}) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    gap={1}
    height={height}
    width="100%"
    bgcolor="#FCFAFA"
    borderRadius="12px"
  >
    <Box mb={1}>
      <img
        src="https://assets.languify.in/images/no_data.png"
        alt=""
        width={151}
        height={97}
      />
    </Box>
    <Typography variant="h6-medium" color="neutral.clr-900">
      {message}
    </Typography>
    {hint && (
      <Typography variant="body01-medium" color="neutral.clr-600" textAlign="center">
        {hint}
      </Typography>
    )}
  </Box>
);

export default NoDataPanel;
